import dayjs, { Dayjs } from 'dayjs';

import '../locale/dayjsLocaleSetup';

type DateInput = string | null | Date | undefined | Dayjs;

// Uses dayjs's localized format tokens (`ll`, `LT`, …) with the global locale, which the app
// sets from the browser at startup via setDateLocale(). They render with locale-correct order
// and conventions — e.g. `15 Jan 2025` for en-GB vs `Jan 15, 2025` for en-US, 24h vs 12h time.
export const formatDateTime = (date: DateInput) => dayjs(date).format('ll LT');

export const formatDate = (date: DateInput) => dayjs(date).format('ll');

export const formatTime = (date: DateInput) => dayjs(date).format('LT');
